import { useEffect, useState } from 'react';

export function useCountdownSeconds(targetAt: number | null | undefined, tickMs = 250) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!targetAt) return undefined;
    if (targetAt <= Date.now()) return undefined;

    const id = window.setInterval(() => setNow(Date.now()), tickMs);
    return () => window.clearInterval(id);
  }, [targetAt, tickMs]);

  if (!targetAt) return 0;
  const diffMs = targetAt - now;
  return diffMs > 0 ? Math.ceil(diffMs / 1000) : 0;
}
